var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99956 11.9022C10.9351 11.9022 11.6934 11.1436 11.6934 10.2079C11.6934 9.27217 10.9351 8.51361 9.99956 8.51361C9.06407 8.51361 8.30569 9.27217 8.30569 10.2079C8.30569 11.1436 9.06407 11.9022 9.99956 11.9022Z",
    fill: "#2D3232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99964 4.48477C11.1313 4.48477 12.2376 4.82044 13.1785 5.44932C14.1195 6.0782 14.8529 6.97205 15.286 8.01784C15.719 9.06362 15.8324 10.2144 15.6116 11.3246C15.3908 12.4348 14.8458 13.4546 14.0456 14.255C13.2454 15.0554 12.2259 15.6005 11.1159 15.8213C10.006 16.0422 8.8555 15.9288 7.80997 15.4956C6.76443 15.0625 5.87079 14.3289 5.24207 13.3877C4.61334 12.4465 4.27776 11.34 4.27776 10.208C4.27948 8.69066 4.88287 7.23592 5.95556 6.16298C7.02824 5.09003 8.48263 4.48649 9.99964 4.48477ZM9.99964 14.3052C10.8098 14.3052 11.6017 14.0649 12.2754 13.6147C12.949 13.1645 13.474 12.5246 13.784 11.776C14.0941 11.0273 14.1752 10.2035 14.0171 9.40871C13.8591 8.61393 13.469 7.88388 12.8961 7.31088C12.3232 6.73787 11.5934 6.34765 10.7988 6.18956C10.0042 6.03147 9.18057 6.11261 8.43209 6.42272C7.6836 6.73282 7.04386 7.25797 6.59376 7.93175C6.14367 8.60553 5.90343 9.39768 5.90343 10.208C5.90465 11.2943 6.33661 12.3357 7.10453 13.1038C7.87246 13.8719 8.91363 14.304 9.99964 14.3052Z",
    fill: "#2D3232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99959 16.4416C4.6882 16.4416 0.53379 10.9274 0.359355 10.6926L0 10.2079L0.359761 9.72327C0.534033 9.48855 4.68844 3.97415 10 3.97415C15.3116 3.97415 19.4659 9.48846 19.6402 9.72327L20 10.2079L19.6402 10.6926C19.4655 10.9274 15.3111 16.4416 9.99959 16.4416ZM2.05989 10.2079C3.14828 11.4806 6.34898 14.8155 9.99959 14.8155C13.6613 14.8155 16.8547 11.4815 17.94 10.2086C16.8521 8.93633 13.6508 5.60022 9.99959 5.60022C6.34841 5.60022 3.1482 8.93519 2.05989 10.2079Z",
    fill: "#2D3232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8124 2.59436H9.18678V0.250305H10.8124V2.59436Z",
    fill: "#2D3232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15094 3.66851L4.29282 1.48731L5.80551 0.891846L6.66371 3.07313L5.15094 3.66851Z",
    fill: "#2D3232"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78872 6.14615L0.191658 4.43073L1.38133 3.32257L2.97839 5.03807L1.78872 6.14615Z",
    fill: "#2D3232"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8483 3.66851L13.3356 3.07313L14.1938 0.891846L15.7065 1.48731L14.8483 3.66851Z",
    fill: "#2D3232"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2106 6.14615L17.0209 5.03799L18.618 3.32257L19.8077 4.43073L18.2106 6.14615Z",
    fill: "#2D3232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowEye);
export default __webpack_public_path__ + "static/media/showEye.ac30424bd652a17d6fffbd06a1f6962c.svg";
export { ForwardRef as ReactComponent };